export const TENANT = 'galactica'

// You probably don't need to change these
export const API_BASE_URL = `https://api.leanspace.io`
export const AWS_REGION = 'eu-central-1'
